import {useContext} from "react";
import Button from "../button/button.component";
import {
    InfoContacts,
    Car,
    IllustrationMinus,
    Smoke,
    PreviewPageIllustration,
    InfoText,
    PreviewPageContainer,
    PreviewPageInfo,
    PreviewPageWrapper,
    Telephone,
    Trust
} from "./preview-page.styles";
import telefon from '../../assets/icons/phone.svg';
import smoke from '../../assets/img/smoke-min.png';
import car from '../../assets/img/main-reica.png';
import trustRu from '../../assets/img/good-service-ru.png';
import trustRo from '../../assets/img/good-service-ro.png';
import {Link} from "react-scroll";
import {LanguageContext} from "../../contexts/language.context";

import "./styles.scss"

const PreviewPage = ({props}) => {
    // console.log('props', props)
    const {romanianLanguage} = useContext(LanguageContext)
    return (
        <PreviewPageWrapper id="home">
            <PreviewPageContainer className="hero_container">
                <PreviewPageInfo>
                    <InfoText className="hero_info-text">
                        <h1>{props[1]}<br/><span>{props[2]}</span></h1>
                        <span className="intro">{props[3]}</span>
                    </InfoText>
                    <InfoContacts>
                        <Link to="form" spy={true} smooth={true} offset={0} duration={500}>
                            <Button children={props[4]}/>
                        </Link>

                        <Telephone>
                            <a href="tel:+37378763821">
                                <img src={telefon} alt=""/>
                                <span>078 763 821</span>
                            </a>
                        </Telephone>
                    </InfoContacts>
                </PreviewPageInfo>

                <PreviewPageIllustration>
                    <IllustrationMinus>
                        <div className="background"></div>
                        <Car>
                            <img src={car} alt=""/>
                        </Car>
                        <Link to="why-us" spy={true} smooth={true} offset={-150} duration={500}>
                            <Trust>
                                <img src={romanianLanguage ? trustRo : trustRu} alt=""/>
                            </Trust>
                        </Link>
                    </IllustrationMinus>
                </PreviewPageIllustration>
            </PreviewPageContainer>
            <Smoke>
                <img src={smoke} alt="smoke"/>
            </Smoke>
        </PreviewPageWrapper>
    )
}
export default PreviewPage;